import './bugsnag';
import Vue from 'vue'

Vue.component('login-form', require('./forms/LoginForm.vue').default);

Vue.prototype.$csrfToken = window.Laravel.csrfToken;

// provide old data and errors to all vue
Vue.prototype.$old = window.Laravel.old;
Vue.prototype.$errors = window.Laravel.errors;

new Vue({
    el: '#app'
});